export default function DesignPreviewElementsSvg() {
	return (
		<svg width="100%" height="auto" viewBox="0 0 1920 342" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path d="M0.105713 216C170.272 90.1667 600.106 -112.2 958.106 85.0001C1316.11 282.2 1749.27 210.833 1921.11 150.5" stroke="white" strokeOpacity="0.8" strokeWidth="4"/>
			<path d="M0.105713 340C170.272 143.691 600.106 -172.015 958.106 135.631C1316.11 443.277 1749.27 331.94 1921.11 237.815" stroke="#C6C6C6" strokeOpacity="0.2" strokeWidth="4"/>
		</svg>
	)
}